import React, { useState, useEffect } from 'react';
import { useCustomMutation } from '../../../utils/useCustomMutation';
import { deleteMethod } from '../../../api/common';
import { ConfirmModal } from '../../../components/modal/confirm-modal/ConfirmModal.component';

const RevokeExemptionModal = ({
  openModal,
  cancelAction,
  studentName,
  exemptionId,
  onSuccess,
}) => {
  const [internalOpenModal, setInternalOpenModal] = useState(openModal);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    setInternalOpenModal(openModal);
  }, [openModal]);

  useEffect(() => {
    if (!openModal) {
      setErrorMessage(null);
    }
  }, [openModal]);

  const { trigger, isMutating } = useCustomMutation(
    `report-lock/exemptions/${exemptionId}`,
    (url) => deleteMethod(url),
    {
      onSuccess: () => {
        if (onSuccess) onSuccess();
      },
      onError: (err) => {
        setErrorMessage(err.message);
      },
    },
  );

  const handleRevoke = async () => {
    setErrorMessage(null);
    if (isMutating || !exemptionId) return;
    await trigger();
  };

  return (
    <ConfirmModal
      isOpen={internalOpenModal}
      closeModal={cancelAction}
      title="Revoke Exemption"
      description={
        <>
          <div>Are you sure you want to revoke this student</div>
          <div className="mt-10 text-primary font-bold">"{studentName}"</div>
        </>
      }
      actionText="REVOKE"
      onClick={handleRevoke}
      disabled={isMutating}
      isLoading={isMutating}
      errorMessage={errorMessage}
      actionBtnClasses="danger"
    />
  );
};

export default RevokeExemptionModal;
